import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { catchError, lastValueFrom, map, throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

declare const saveAs: (blob: Blob, fileName: string) => void;

@Injectable({ providedIn: 'root' })
export class DocumentService {
    constructor(
        private http: HttpClient,
        private toastr: ToastrService,
    ) {}

    readonly SERVICE_URL = '/api/DocumentIntake/';

    getDocumentBody(id: string): Promise<any> {
        const obsv = this.http
            .get(`/api/attachment/${id}`, {
                responseType: 'arraybuffer',
                observe: 'response',
            })
            .pipe(
                map((response: HttpResponse<ArrayBuffer>) => {
                    console.log(response)
                    const contentDisposition = response.headers.get('Content-Disposition');

                    if (!contentDisposition) {
                        this.toastr.error('Document not found');
                        // mimic reject()
                        throw new Error('Document not found');
                    }

                    // mimic resolve(result) -> return body
                    return response;
                }),
                catchError((err) => {
                    // this is like the "reject" handler in your original then(...)
                    return throwError(() => err);
                }),
            );

        return lastValueFrom(obsv);
    }

    getDocumentInfo(id) {
        return lastValueFrom(this.http.get(this.SERVICE_URL + id));
    }

    getDocumentInfoByTaskId(id) {
        return lastValueFrom(this.http.get(this.SERVICE_URL + 'task/' + id));
    }

    getTaskInfo(id) {
        return lastValueFrom(this.http.get(this.SERVICE_URL + id + '/taskInfo'));
    }

    getTaskInfoByTaskID(id) {
        return lastValueFrom(this.http.get(this.SERVICE_URL + 'task/' + id + '/taskInfo'));
    }

    saveFile(blob: Blob, fileName: string) {
        const saveBlob =
            saveAs || navigator.webkitSaveBlob || navigator.mozSaveBlob || navigator.saveBlob || navigator.msSaveBlob;

        saveBlob(blob, fileName);
    }

    mapDocumentToEntity(id, data) {
        return lastValueFrom(this.http.patch(this.SERVICE_URL + id, data));
    }

    put(data) {
        return lastValueFrom(this.http.put(this.SERVICE_URL, data));
    }
}
